import React from 'react';
import { StarIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Testimonials() {
  const testimonials = [{
    id: 1,
    name: 'Greg M.',
    age: 54,
    rating: 5,
    comment: 'I was skeptical, but after 2 weeks I feel like a new man. More energy, better workouts, and my wife has definitely noticed the difference.'
  }, {
    id: 2,
    name: 'Steve P.',
    age: 46,
    rating: 5,
    comment: "These gummies taste great and actually work. I've tried everything, and this is the only supplement that's made a real difference in my day-to-day life."
  }, {
    id: 3,
    name: 'John B.',
    age: 62,
    rating: 4,
    comment: "At my age, I didn't think anything would help. I'm sleeping better and have more energy to play with my grandkids. Worth every penny."
  }, {
    id: 4,
    name: 'Mark L.',
    age: 51,
    rating: 5,
    comment: "The difference in my workouts is night and day. I'm lifting weights I haven't touched in years, and recovery is much faster."
  }];
  return <section className="px-4 py-8 md:py-12 bg-white rounded-lg shadow-sm mx-4 my-8" data-id="element-73">
      <h2 className="text-2xl md:text-3xl font-bold text-gray-900 text-center mb-8" data-id="element-74">
        What Men Are Saying About Alpha Gummies
      </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-75">
        {testimonials.map(testimonial => <div key={testimonial.id} className="border border-gray-200 rounded-lg p-4 shadow-sm" data-id="element-76">
            <div className="flex justify-between items-center mb-3" data-id="element-77">
              <p className="font-medium text-gray-900" data-id="element-78">
                {testimonial.name}, {testimonial.age}
              </p>
              <div className="flex" data-id="element-79">
                {[...Array(5)].map((_, i) => <StarIcon key={i} size={16} className={i < testimonial.rating ? 'fill-yellow-400 text-yellow-400' : 'text-gray-300'} data-id="element-80" />)}
              </div>
            </div>
            <p className="text-gray-700" data-id="element-81">{testimonial.comment}</p>
          </div>)}
      </div>
      <div className="mt-8 text-center" data-id="element-82">
        <p className="text-xl font-medium text-gray-900 mb-4" data-id="element-83">
          Join thousands of satisfied customers!
        </p>
        <CTAButton data-id="element-84" />
      </div>
    </section>;
}